/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Types from '../../generated/types'

import { gql } from '@apollo/client'
import { FilterFragmentDoc } from '../../ux/Filter/Filter.generated'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type FiltersByIdsQueryVariables = Types.Exact<{
  appId: Types.Scalars['ID']
  projectId?: Types.InputMaybe<Types.Scalars['Int']>
  filterIds: Array<Types.Scalars['ID']> | Types.Scalars['ID']
  extraInputs: Array<Types.QueryInput> | Types.QueryInput
}>

export type FiltersByIdsQuery = {
  __typename?: 'Query'
  app?: {
    __typename?: 'App'
    filtersByIds: Array<
      | {
          __typename: 'BooleanField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          state?: boolean | null
          localEdited?: boolean | null
          localState?: boolean | null
        }
      | {
          __typename: 'DateField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          date?: any | null
          localEdited?: boolean | null
          localDate?: string | null
        }
      | {
          __typename: 'DateTimeField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          dateTime?: any | null
          localEdited?: boolean | null
          localDateTime?: string | null
        }
      | {
          __typename: 'DownloadFileField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          selection?: {
            __typename?: 'SelectField'
            style?: Types.SelectStyle | null
            localEdited?: boolean | null
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
            selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
            localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
          } | null
        }
      | {
          __typename: 'MultiSelectField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          style?: Types.SelectStyle | null
          localEdited?: boolean | null
          options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          selections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          localSelections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
        }
      | {
          __typename: 'NumberField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          value?: number | null
          localEdited?: boolean | null
          localValue?: number | null
        }
      | {
          __typename: 'NumberRangeField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
        }
      | {
          __typename: 'SelectField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          style?: Types.SelectStyle | null
          localEdited?: boolean | null
          options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
          localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
        }
      | {
          __typename: 'TextField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          text?: string | null
          localEdited?: boolean | null
          localText?: string | null
        }
      | {
          __typename: 'UploadFileField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          overrideAppId?: string | null
          templateId?: string | null
          entityId?: string | null
        }
      | null
    >
  } | null
}

export type FilterByIdQueryVariables = Types.Exact<{
  appId: Types.Scalars['ID']
  projectId?: Types.InputMaybe<Types.Scalars['Int']>
  filterId: Types.Scalars['ID']
}>

export type FilterByIdQuery = {
  __typename?: 'Query'
  app?: {
    __typename?: 'App'
    filterById?:
      | {
          __typename: 'BooleanField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          state?: boolean | null
          localEdited?: boolean | null
          localState?: boolean | null
        }
      | {
          __typename: 'DateField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          date?: any | null
          localEdited?: boolean | null
          localDate?: string | null
        }
      | {
          __typename: 'DateTimeField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          dateTime?: any | null
          localEdited?: boolean | null
          localDateTime?: string | null
        }
      | {
          __typename: 'DownloadFileField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          selection?: {
            __typename?: 'SelectField'
            style?: Types.SelectStyle | null
            localEdited?: boolean | null
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
            selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
            localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
          } | null
        }
      | {
          __typename: 'MultiSelectField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          style?: Types.SelectStyle | null
          localEdited?: boolean | null
          options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          selections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          localSelections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
        }
      | {
          __typename: 'NumberField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          value?: number | null
          localEdited?: boolean | null
          localValue?: number | null
        }
      | {
          __typename: 'NumberRangeField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
        }
      | {
          __typename: 'SelectField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          style?: Types.SelectStyle | null
          localEdited?: boolean | null
          options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
          localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
        }
      | {
          __typename: 'TextField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          text?: string | null
          localEdited?: boolean | null
          localText?: string | null
        }
      | {
          __typename: 'UploadFileField'
          id: string
          label?: string | null
          description?: string | null
          information?: string | null
          overrideAppId?: string | null
          templateId?: string | null
          entityId?: string | null
        }
      | null
  } | null
}

export type PageFilterIdsQueryVariables = Types.Exact<{
  appId: Types.Scalars['ID']
  pageId: Types.Scalars['ID']
  projectId?: Types.InputMaybe<Types.Scalars['Int']>
}>

export type PageFilterIdsQuery = {
  __typename?: 'Query'
  app?: {
    __typename?: 'App'
    pageById?: {
      __typename?: 'Page'
      primaryFilterIds?: Array<string> | null
      filterIds?: Array<string> | null
      hierarchicalFilterIds?: Array<string> | null
    } | null
  } | null
}

export const FiltersByIdsDocument = gql`
  query FiltersByIds($appId: ID!, $projectId: Int, $filterIds: [ID!]!, $extraInputs: [QueryInput!]!) {
    app(id: $appId, projectId: $projectId, extraInputs: $extraInputs, filters: []) {
      filtersByIds(ids: $filterIds) {
        ...Filter
      }
    }
  }
  ${FilterFragmentDoc}
`

/**
 * __useFiltersByIdsQuery__
 *
 * To run a query within a React component, call `useFiltersByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiltersByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiltersByIdsQuery({
 *   variables: {
 *      appId: // value for 'appId'
 *      projectId: // value for 'projectId'
 *      filterIds: // value for 'filterIds'
 *      extraInputs: // value for 'extraInputs'
 *   },
 * });
 */
export function useFiltersByIdsQuery(
  baseOptions: Apollo.QueryHookOptions<FiltersByIdsQuery, FiltersByIdsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FiltersByIdsQuery, FiltersByIdsQueryVariables>(FiltersByIdsDocument, options)
}
export function useFiltersByIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FiltersByIdsQuery, FiltersByIdsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FiltersByIdsQuery, FiltersByIdsQueryVariables>(FiltersByIdsDocument, options)
}
export type FiltersByIdsQueryHookResult = ReturnType<typeof useFiltersByIdsQuery>
export type FiltersByIdsLazyQueryHookResult = ReturnType<typeof useFiltersByIdsLazyQuery>
export type FiltersByIdsQueryResult = Apollo.QueryResult<FiltersByIdsQuery, FiltersByIdsQueryVariables>
export const FilterByIdDocument = gql`
  query FilterById($appId: ID!, $projectId: Int, $filterId: ID!) {
    app(id: $appId, projectId: $projectId, filters: []) {
      filterById(id: $filterId) {
        ...Filter
      }
    }
  }
  ${FilterFragmentDoc}
`

/**
 * __useFilterByIdQuery__
 *
 * To run a query within a React component, call `useFilterByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterByIdQuery({
 *   variables: {
 *      appId: // value for 'appId'
 *      projectId: // value for 'projectId'
 *      filterId: // value for 'filterId'
 *   },
 * });
 */
export function useFilterByIdQuery(baseOptions: Apollo.QueryHookOptions<FilterByIdQuery, FilterByIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FilterByIdQuery, FilterByIdQueryVariables>(FilterByIdDocument, options)
}
export function useFilterByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FilterByIdQuery, FilterByIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FilterByIdQuery, FilterByIdQueryVariables>(FilterByIdDocument, options)
}
export type FilterByIdQueryHookResult = ReturnType<typeof useFilterByIdQuery>
export type FilterByIdLazyQueryHookResult = ReturnType<typeof useFilterByIdLazyQuery>
export type FilterByIdQueryResult = Apollo.QueryResult<FilterByIdQuery, FilterByIdQueryVariables>
export const PageFilterIdsDocument = gql`
  query PageFilterIds($appId: ID!, $pageId: ID!, $projectId: Int) {
    app(id: $appId, projectId: $projectId, filters: []) {
      pageById(id: $pageId) {
        primaryFilterIds
        filterIds
        hierarchicalFilterIds
      }
    }
  }
`

/**
 * __usePageFilterIdsQuery__
 *
 * To run a query within a React component, call `usePageFilterIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageFilterIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageFilterIdsQuery({
 *   variables: {
 *      appId: // value for 'appId'
 *      pageId: // value for 'pageId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePageFilterIdsQuery(
  baseOptions: Apollo.QueryHookOptions<PageFilterIdsQuery, PageFilterIdsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PageFilterIdsQuery, PageFilterIdsQueryVariables>(PageFilterIdsDocument, options)
}
export function usePageFilterIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PageFilterIdsQuery, PageFilterIdsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PageFilterIdsQuery, PageFilterIdsQueryVariables>(PageFilterIdsDocument, options)
}
export type PageFilterIdsQueryHookResult = ReturnType<typeof usePageFilterIdsQuery>
export type PageFilterIdsLazyQueryHookResult = ReturnType<typeof usePageFilterIdsLazyQuery>
export type PageFilterIdsQueryResult = Apollo.QueryResult<PageFilterIdsQuery, PageFilterIdsQueryVariables>
